type CurrencyDollarCircleIconProps = {
  color?: string;
  size?: string | number;
};

export const CurrencyDollarCircleIcon = ({
  size = '20',
  color = 'currentColor',
}: CurrencyDollarCircleIconProps): JSX.Element => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 18.3333C14.6024 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39763 14.6024 1.66667 10 1.66667C5.39765 1.66667 1.66669 5.39763 1.66669 10C1.66669 14.6024 5.39765 18.3333 10 18.3333Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.50002 11.6667C7.50002 12.5871 8.24621 13.3333 9.16669 13.3333H10.8334C11.7538 13.3333 12.5 12.5871 12.5 11.6667C12.5 10.7462 11.7538 10 10.8334 10H9.16669C8.24621 10 7.50002 9.25381 7.50002 8.33333C7.50002 7.41286 8.24621 6.66667 9.16669 6.66667H10.8334C11.7538 6.66667 12.5 7.41286 12.5 8.33333M10 5.83333V14.1667"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
